import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const ProductLandingPage = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12731"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12731)">
          <rect
            x="-37"
            y="-2"
            width="173"
            height="113"
            rx="5.58629"
            fill="#FFEDBF"
          />
          <path
            d="M82.26 37.6445V87.0798C82.26 88.7187 81.6089 90.2904 80.4501 91.4493C79.2912 92.6082 77.7195 93.2592 76.0806 93.2592H17.3762C15.7373 93.2592 14.1655 92.6082 13.0067 91.4493C11.8478 90.2904 11.1968 88.7187 11.1968 87.0798V37.6445H82.26Z"
            fill="#66E1FF"
          />
          <path
            d="M11.1968 37.6445V87.0798C11.1968 88.7187 11.8478 90.2904 13.0067 91.4493C14.1655 92.6082 15.7373 93.2592 17.3762 93.2592H20.4659L76.0806 37.6445H11.1968Z"
            fill="#C2F3FF"
          />
          <path
            d="M82.26 37.6442H11.1968V28.3751C11.1968 26.7362 11.8478 25.1644 13.0067 24.0056C14.1655 22.8467 15.7373 22.1957 17.3762 22.1957H76.0806C77.7195 22.1957 79.2912 22.8467 80.4501 24.0056C81.6089 25.1644 82.26 26.7362 82.26 28.3751V37.6442Z"
            fill="white"
          />
          <path
            d="M76.0806 22.1957H17.3762C15.7373 22.1957 14.1655 22.8467 13.0067 24.0056C11.8478 25.1644 11.1968 26.7362 11.1968 28.3751V87.0795C11.1968 88.7184 11.8478 90.2901 13.0067 91.449C14.1655 92.6078 15.7373 93.2589 17.3762 93.2589H76.0806C77.7195 93.2589 79.2912 92.6078 80.4501 91.449C81.6089 90.2901 82.26 88.7184 82.26 87.0795V28.3751C82.26 26.7362 81.6089 25.1644 80.4501 24.0056C79.2912 22.8467 77.7195 22.1957 76.0806 22.1957Z"
            stroke="#191919"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.1968 37.6445H82.26"
            stroke="#191919"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.0107 30.6924C21.8058 30.6924 21.6094 30.6111 21.4645 30.4662C21.3197 30.3213 21.2383 30.1249 21.2383 29.92C21.2383 29.7151 21.3197 29.5187 21.4645 29.3738C21.6094 29.229 21.8058 29.1476 22.0107 29.1476"
            stroke="#191919"
            strokeWidth="1.01608"
          />
          <path
            d="M22.0107 30.6924C22.2156 30.6924 22.4121 30.6111 22.5569 30.4662C22.7018 30.3213 22.7832 30.1249 22.7832 29.92C22.7832 29.7151 22.7018 29.5187 22.5569 29.3738C22.4121 29.229 22.2156 29.1476 22.0107 29.1476"
            stroke="#191919"
            strokeWidth="1.01608"
          />
          <path
            d="M71.4459 43.7241H22.0107C21.601 43.7241 21.208 43.8869 20.9183 44.1766C20.6286 44.4663 20.4658 44.8593 20.4658 45.269V51.4484C20.4658 51.8581 20.6286 52.251 20.9183 52.5408C21.208 52.8305 21.601 52.9932 22.0107 52.9932H71.4459C71.8557 52.9932 72.2486 52.8305 72.5383 52.5408C72.828 52.251 72.9908 51.8581 72.9908 51.4484V45.269C72.9908 44.8593 72.828 44.4663 72.5383 44.1766C72.2486 43.8869 71.8557 43.7241 71.4459 43.7241Z"
            fill="#FFEF5E"
          />
          <path
            d="M22.0107 43.7241C21.601 43.7241 21.208 43.8869 20.9183 44.1766C20.6286 44.4663 20.4658 44.8593 20.4658 45.269V51.4484C20.4658 51.8581 20.6286 52.251 20.9183 52.5408C21.208 52.8305 21.601 52.9932 22.0107 52.9932H57.5423L66.8114 43.7241H22.0107Z"
            fill="#FFF9BF"
          />
          <path
            d="M71.4459 43.7241H22.0107C21.601 43.7241 21.208 43.8869 20.9183 44.1766C20.6286 44.4663 20.4658 44.8593 20.4658 45.269V51.4484C20.4658 51.8581 20.6286 52.251 20.9183 52.5408C21.208 52.8305 21.601 52.9932 22.0107 52.9932H71.4459C71.8557 52.9932 72.2486 52.8305 72.5383 52.5408C72.828 52.251 72.9908 51.8581 72.9908 51.4484V45.269C72.9908 44.8593 72.828 44.4663 72.5383 44.1766C72.2486 43.8869 71.8557 43.7241 71.4459 43.7241Z"
            stroke="#191919"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.493 59.5618H22.3301C22.0341 59.5618 21.7502 59.6794 21.5408 59.8887C21.3315 60.0981 21.2139 60.382 21.2139 60.678V69.6083C21.2139 69.9043 21.3315 70.1883 21.5408 70.3976C21.7502 70.607 22.0341 70.7246 22.3301 70.7246H33.493C33.789 70.7246 34.0729 70.607 34.2823 70.3976C34.4916 70.1883 34.6092 69.9043 34.6092 69.6083V60.678C34.6092 60.382 34.4916 60.0981 34.2823 59.8887C34.0729 59.6794 33.789 59.5618 33.493 59.5618Z"
            fill="#FFEF5E"
            stroke="#191919"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.5713 59.8583L34.2522 70.4272"
            stroke="#191919"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.5713 70.4272L34.2522 59.8583"
            stroke="#191919"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.493 75.509H22.3301C22.0341 75.509 21.7502 75.6266 21.5408 75.836C21.3315 76.0453 21.2139 76.3293 21.2139 76.6253V85.5556C21.2139 85.8516 21.3315 86.1355 21.5408 86.3449C21.7502 86.5542 22.0341 86.6718 22.3301 86.6718H33.493C33.789 86.6718 34.0729 86.5542 34.2823 86.3449C34.4916 86.1355 34.6092 85.8516 34.6092 85.5556V76.6253C34.6092 76.3293 34.4916 76.0453 34.2823 75.836C34.0729 75.6266 33.789 75.509 33.493 75.509Z"
            fill="#FFEF5E"
            stroke="#191919"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.5713 75.8055L34.2522 86.3745"
            stroke="#191919"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.5713 86.3745L34.2522 75.8055"
            stroke="#191919"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.1934 61.157H73.0904"
            stroke="#191919"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.1934 67.3361H66.7117"
            stroke="#191919"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.1934 73.5155H69.8512"
            stroke="#191919"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.1934 79.4456H63.8213"
            stroke="#191919"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.1934 85.0774H55.8479"
            stroke="#191919"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.2802 30.6924C31.0754 30.6924 30.8789 30.6111 30.7341 30.4662C30.5892 30.3213 30.5078 30.1249 30.5078 29.92C30.5078 29.7151 30.5892 29.5187 30.7341 29.3738C30.8789 29.229 31.0754 29.1476 31.2802 29.1476"
            stroke="#191919"
            strokeWidth="1.01608"
          />
          <path
            d="M31.2798 30.6924C31.4846 30.6924 31.6811 30.6111 31.826 30.4662C31.9708 30.3213 32.0522 30.1249 32.0522 29.92C32.0522 29.7151 31.9708 29.5187 31.826 29.3738C31.6811 29.229 31.4846 29.1476 31.2798 29.1476"
            stroke="#191919"
            strokeWidth="1.01608"
          />
          <path
            d="M40.5493 30.6924C40.3444 30.6924 40.148 30.6111 40.0031 30.4662C39.8582 30.3213 39.7769 30.1249 39.7769 29.92C39.7769 29.7151 39.8582 29.5187 40.0031 29.3738C40.148 29.229 40.3444 29.1476 40.5493 29.1476"
            stroke="#191919"
            strokeWidth="1.01608"
          />
          <path
            d="M40.5493 30.6926C40.7542 30.6926 40.9506 30.6112 41.0955 30.4663C41.2404 30.3215 41.3217 30.125 41.3217 29.9201C41.3217 29.7153 41.2404 29.5188 41.0955 29.3739C40.9506 29.2291 40.7542 29.1477 40.5493 29.1477"
            stroke="#191919"
            strokeWidth="1.01608"
          />
          <path
            d="M104.941 28.4071L102.222 25.5674L102.323 25.14L103.136 21.7623C103.176 21.578 103.144 21.3857 103.046 21.2239C102.949 21.062 102.793 20.9426 102.61 20.8895L98.8228 19.773L97.6943 16.0247C97.6528 15.8882 97.5727 15.7663 97.4635 15.6733C97.3543 15.5804 97.2205 15.5202 97.0779 15.5001C96.9809 15.4842 96.8818 15.4877 96.7863 15.5105L92.9474 16.4073L90.077 13.717C89.9344 13.5869 89.7475 13.5146 89.5535 13.5146C89.3595 13.5146 89.1726 13.5869 89.03 13.717L86.1596 16.4073L82.3222 15.5045C82.1363 15.4651 81.9423 15.4964 81.7788 15.5923C81.6152 15.6881 81.4942 15.8415 81.4399 16.0217L80.3084 19.7715L76.5193 20.8865C76.3326 20.9409 76.1743 21.0645 76.0775 21.2316C75.9807 21.3987 75.9528 21.5963 75.9996 21.7832L76.9061 25.5869L74.7336 27.8482L74.7004 27.881L74.1867 28.4206C74.0546 28.5592 73.981 28.7426 73.981 28.9332C73.981 29.1238 74.0546 29.3072 74.1867 29.4458L74.5961 29.8748L75.2004 30.507L75.2443 30.5503L76.9061 32.2855L75.9996 36.0892C75.9527 36.2759 75.9804 36.4733 76.0769 36.6404C76.1734 36.8074 76.3314 36.9312 76.5178 36.9859L80.3068 38.1024L81.4354 41.8507C81.4904 42.0335 81.614 42.1886 81.7808 42.2842C81.9477 42.3798 82.1451 42.4086 82.3328 42.3649L86.1792 41.4681L88.4453 43.5904L88.5043 43.6502L89.0496 44.1583C89.1898 44.2891 89.3752 44.3619 89.5678 44.3619C89.7605 44.3619 89.9459 44.2891 90.086 44.1583L91.6814 42.6638L92.9565 41.4681L96.8014 42.3649C96.9903 42.4112 97.1901 42.3836 97.359 42.2878C97.5279 42.1921 97.6528 42.0355 97.7079 41.8507L98.8364 38.1039L102.625 36.9874C102.812 36.933 102.97 36.8093 103.067 36.6423C103.164 36.4752 103.192 36.2776 103.145 36.0907L102.55 33.6127L102.233 32.2855L104.952 29.4458C105.084 29.3056 105.157 29.1211 105.157 28.9295C105.157 28.7378 105.084 28.5533 104.952 28.4131L104.941 28.4071Z"
            fill="#FFEF5E"
          />
          <path
            d="M75.201 30.5116L74.1868 29.4488C74.0546 29.3101 73.981 29.1267 73.981 28.936C73.981 28.7454 74.0546 28.562 74.1868 28.4233L76.9073 25.583L76.0005 21.7771C75.9562 21.5914 75.9854 21.396 76.0821 21.2309C76.1787 21.0658 76.3356 20.9436 76.5204 20.8891L80.311 19.7725L81.4401 16.0233C81.4941 15.8422 81.6155 15.688 81.7798 15.5918C81.9441 15.4955 82.1392 15.4644 82.3257 15.5046L86.1723 16.409L89.0439 13.7182C89.1842 13.5875 89.3696 13.5146 89.5624 13.5146C89.7551 13.5146 89.9405 13.5875 90.0808 13.7182L92.9524 16.409L96.8005 15.5121C96.9882 15.4683 97.1858 15.4972 97.3527 15.5928C97.5196 15.6884 97.6432 15.8435 97.6983 16.0263L98.8273 19.7755L102.618 20.8921C102.805 20.9466 102.963 21.0702 103.06 21.2373C103.157 21.4044 103.185 21.6021 103.138 21.7891L102.231 25.5786L104.952 28.4188C105.084 28.5575 105.157 28.7409 105.157 28.9315C105.157 29.1222 105.084 29.3056 104.952 29.4443L102.231 32.2845L103.145 36.089C103.192 36.2759 103.164 36.4736 103.068 36.6407C102.971 36.8078 102.812 36.9315 102.625 36.9859L98.8348 38.1026L97.7058 41.8517C97.6505 42.0362 97.5253 42.1925 97.3564 42.288C97.1875 42.3835 96.9878 42.4109 96.799 42.3644L92.9524 41.4675L90.0808 44.1583C89.9405 44.2891 89.7551 44.3619 89.5624 44.3619C89.3696 44.3619 89.1842 44.2891 89.0439 44.1583L88.4983 43.6485"
            stroke="#1E1E1E"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M74.6831 40.1414L77.3672 42.5883"
            stroke="#1E1E1E"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M82.2861 24.4939L92.4862 33.791"
            stroke="#1E1E1E"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M91.9499 33.3015L76.83 42.0994L75.22 40.6311L82.8215 24.9836L91.9496 33.3003L91.9499 33.3015Z"
            fill="#FF5A4F"
          />
          <path
            d="M91.9499 33.3015L76.83 42.0994L75.22 40.6311L82.8215 24.9836L91.9496 33.3003L91.9499 33.3015Z"
            stroke="#1E1E1E"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M84.6976 37.5201C84.983 37.7189 85.2242 37.9736 85.4064 38.2683C85.5885 38.5631 85.7078 38.8916 85.7567 39.2337C85.8056 39.5758 85.7832 39.9241 85.6908 40.2573C85.5984 40.5904 85.438 40.9012 85.2196 41.1705C85.0011 41.4398 84.7292 41.6619 84.4206 41.823C84.112 41.9842 83.7733 42.081 83.4255 42.1074C83.0776 42.1339 82.7279 42.0895 82.398 41.9769C82.068 41.8643 81.7649 41.686 81.5073 41.4529L80.1054 40.1753"
            stroke="#1E1E1E"
            strokeWidth="1.01608"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M88.3877 26.1067L90.8635 21.6862"
            stroke="black"
            strokeWidth="1.01608"
            strokeLinecap="round"
          />
          <path
            d="M90.4399 27.6708L93.464 26.9062"
            stroke="black"
            strokeWidth="1.01608"
            strokeLinecap="round"
          />
        </g>
      </SvgIcon>
    );
  })
);
ProductLandingPage.displayName = 'ProductLandingPage';
